import React, { useState, useEffect } from 'react';
import api from '../utils/axiosConfig';
import './Checkers.css';
import './TableStyles.css';

const Checkers = () => {
  const [checkers, setCheckers] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    status: 'ATIVO'
  });
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  // Fetch all checkers
  const fetchCheckers = async () => {
    try {
      const response = await api.get('/checkers');
      setCheckers(response.data);
    } catch (error) {
      console.error('Error fetching checkers:', error);
    }
  };

  useEffect(() => {
    fetchCheckers();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        // Update existing checker
        const response = await api.put(`/checkers/${editingId}`, formData);
        setMessage('Conferente atualizado com sucesso!');
        setMessageType('success');
        setEditingId(null);
      } else {
        // Create new checker
        const response = await api.post('/checkers', formData);
        setMessage('Conferente criado com sucesso!');
        setMessageType('success');
      }
      setFormData({ name: '', status: 'ATIVO' });
      fetchCheckers();
      setTimeout(() => {
        setMessage('');
        setMessageType('');
      }, 3000);
    } catch (error) {
      setMessage('Erro ao salvar conferente: ' + (error.response?.data?.message || error.message));
      setMessageType('error');
      console.error('Error saving checker:', error);
      setTimeout(() => {
        setMessage('');
        setMessageType('');
      }, 5000);
    }
  };

  const handleEdit = (checker) => {
    setFormData({
      name: checker.name,
      status: checker.status
    });
    setEditingId(checker._id);
    // Scroll to the form
    document.querySelector('.checker-form').scrollIntoView({ behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este conferente?')) {
      try {
        await api.delete(`/checkers/${id}`);
        setMessage('Conferente excluído com sucesso!');
        setMessageType('success');
        fetchCheckers();
        setTimeout(() => {
          setMessage('');
          setMessageType('');
        }, 3000);
      } catch (error) {
        setMessage('Erro ao excluir conferente: ' + (error.response?.data?.message || error.message));
        setMessageType('error');
        console.error('Error deleting checker:', error);
        setTimeout(() => {
          setMessage('');
          setMessageType('');
        }, 5000);
      }
    }
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setFormData({ name: '', status: 'ATIVO' });
  };

  return (
    <div className="checkers-container">
      <h2>Cadastro de Conferentes</h2>
      
      {message && (
        <div className={`message ${messageType}`}>
          {message}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="checker-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Nome *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="status">Status *</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
        
        <div className="form-actions">
          <button type="submit" className="btn-save">
            {editingId ? 'Atualizar Conferente' : 'Adicionar Conferente'}
          </button>
          {editingId && (
            <button 
              type="button" 
              className="btn-cancel" 
              onClick={handleCancelEdit}
            >
              Cancelar
            </button>
          )}
        </div>
      </form>

      <div className="checkers-list">
        <h3>Conferentes Cadastrados</h3>
        {checkers.length > 0 ? (
          <div className="global-table-container">
            <table className="global-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {checkers.map((checker) => (
                  <tr key={checker._id}>
                    <td>{checker.name}</td>
                    <td>
                      <span className={`status ${checker.status.toLowerCase()}`}>
                        {checker.status === 'ATIVO' ? 'Ativo' : 'Inativo'}
                      </span>
                    </td>
                    <td>
                      <button 
                        className="btn-edit"
                        onClick={() => handleEdit(checker)}
                      >
                        Editar
                      </button>
                      <button 
                        className="btn-delete"
                        onClick={() => handleDelete(checker._id)}
                      >
                        Excluir
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>Nenhum conferente cadastrado.</p>
        )}
      </div>
    </div>
  );
};

export default Checkers;